import { FC } from 'react'
import cx from 'classnames'
import styles from './AthletesSlider.module.scss'
import { Img } from 'components/basic/Img'
import { useSlider } from 'components/_hooks/useSlider'

const slides = [
	{
		imgSrc: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/slide-1.png',
		imgAlt: 'george russel',
		athleteName: 'George Russell',
		athleteInfo: ['Formula One', "King's Lynn, Norfolk, UK", '1x win, 10x podiums'],
	},
	{
		imgSrc: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/taylor-fritz-featured-athlete-slider.jpg',
		imgAlt: 'taylor fritz',
		athleteName: 'Taylor Fritz',
		athleteInfo: ['Tennis', 'Rancho Santa Fe, USA', 'Career-high ranking of world #5'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_medeiros.jpg?v=1690443705',
		imgAlt: 'justin medeiros',
		athleteName: 'Justin Medeiros',
		athleteInfo: ['CrossFit', 'Lodi, California, USA', 'Winner of the 2021 and 2022 CrossFit Games.'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_crosby.jpg?v=1690443721',
		imgAlt: 'sidney crosby',
		athleteName: 'Sidney Crosby',
		athleteInfo: ['Ice hockey', 'Cole Harbour, Nova Scotia, CA', '3x Stanley Cup winner'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_wells.jpg?v=1690443705',
		imgAlt: 'brooke wells',
		athleteName: 'Brooke Wells',
		athleteInfo: ['CrossFit', 'Missouri, USA', '7x CrossFit Games Athlete'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_green.jpg?v=1690443710',
		imgAlt: 'danny green',
		athleteName: 'Danny Green',
		athleteInfo: ['Basketball', 'North Babylon, New York, USA', '3x NBA Champion'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_carapaz.jpg?v=1690443705',
		imgAlt: 'richard carapaz',
		athleteName: 'Richard Carapaz',
		athleteInfo: ['Cycling', 'Tulcán Cantón, Ecuador', "Olympic Gold Medalist and winner of the Giro d'Italia"],
	},
	{
		imgSrc: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/slide-2.png',
		imgAlt: 'chelsea gray',
		athleteName: 'Chelsea Gray',
		athleteInfo: ['Basketball', 'Hayward, California, USA', '2x WNBA Champion'],
	},
	{
		imgSrc: 'https://eightsleep.imgix.net/featured_murphy.jpg?v=1690443705',
		imgAlt: 'ryan murphy',
		athleteName: 'Ryan Murphy',
		athleteInfo: ['Swimming', 'Chicago, Illinois, USA', '4x Olympic Gold Medalist'],
	},
]

export const AthletesSlider: FC = () => {
	const [sliderRef, currentSlide, goToSlide] = useSlider()

	const onPrevClick = () => {
		goToSlide(Math.max(0, currentSlide - 1))
	}
	const onNextClick = () => {
		goToSlide(Math.min(slides.length - 1, currentSlide + 1))
	}

	return (
		<div className={styles.root}>
			<div className={styles.header}>
				<div className={styles.title}>Top athletes recover on the Pod</div>

				<div className={styles.nav}>
					<ArrowLeftCircle
						className={cx(styles.nav_button, { [styles.nav_button_disabled]: currentSlide === 0 })}
						onClick={onPrevClick}
					/>
					<ArrowRightCircle
						className={cx(styles.nav_button, { [styles.nav_button_disabled]: currentSlide === slides.length - 1 })}
						onClick={onNextClick}
					/>
				</div>
			</div>

			<ul
				className={styles.slider}
				ref={sliderRef}
			>
				{slides.map((slide, index) => (
					<li
						key={index}
						className={styles.slide}
						style={{
							opacity: index === currentSlide ? 1 : 0.3,
						}}
					>
						<div className={styles.image_container}>
							<Img
								src={slide.imgSrc}
								alt={slide.imgAlt}
								objectFit="cover"
							/>
						</div>

						<div className={styles.athlete_name}>{slide.athleteName}</div>

						<div className={styles.athlete_info_container}>
							<div className={styles.athlete_info}>
								<div className={styles.athlete_info_title}>Sport</div>
								<div className={styles.athlete_info_content}>{slide.athleteInfo[0]}</div>
							</div>

							<div className={styles.athlete_info}>
								<div className={styles.athlete_info_title}>Hometown</div>
								<div className={styles.athlete_info_content}>{slide.athleteInfo[1]}</div>
							</div>

							<div className={styles.athlete_info}>
								<div className={styles.athlete_info_title}>Accomplishments</div>
								<div className={styles.athlete_info_content}>{slide.athleteInfo[2]}</div>
							</div>
						</div>
					</li>
				))}
			</ul>
		</div>
	)
}

const ArrowLeftCircle = ({ className, onClick }) => (
	<svg
		width="50"
		height="50"
		viewBox="0 0 50 50"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		onClick={onClick}
	>
		<circle
			cx="25"
			cy="25"
			r="25"
			fill="#39393b"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.453 34.032C26.5635 34.1937 26.709 34.3283 26.8787 34.426C27.0484 34.5236 27.2379 34.5818 27.4332 34.5961C27.6284 34.6104 27.8244 34.5805 28.0065 34.5086C28.1886 34.4367 28.3522 34.3247 28.485 34.1808L28.605 34.0528C28.8318 33.8067 28.9693 33.4914 28.9954 33.1577C29.0216 32.8241 28.9348 32.4913 28.749 32.2128L22.813 24.9552L28.749 17.7872C28.9348 17.5088 29.0216 17.176 28.9954 16.8423C28.9693 16.5086 28.8318 16.1934 28.605 15.9472L28.485 15.8192C28.3522 15.6754 28.1886 15.5634 28.0065 15.4915C27.8244 15.4196 27.6284 15.3897 27.4332 15.404C27.2379 15.4183 27.0484 15.4764 26.8787 15.5741C26.709 15.6717 26.5635 15.8064 26.453 15.968L19.6738 24.0928C19.4958 24.3452 19.4002 24.6464 19.4002 24.9552C19.4002 25.264 19.4958 25.5653 19.6738 25.8176L26.453 34.032Z"
			fill="#d2d2d3"
		/>
	</svg>
)

const ArrowRightCircle = ({ className, onClick }) => (
	<svg
		width="50"
		height="50"
		viewBox="0 0 50 50"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		onClick={onClick}
	>
		<circle
			cx="25"
			cy="25"
			r="25"
			fill="#39393b"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.547 15.968C23.4365 15.8063 23.291 15.6717 23.1213 15.574C22.9516 15.4764 22.7621 15.4182 22.5668 15.4039C22.3716 15.3896 22.1756 15.4195 21.9935 15.4914C21.8114 15.5633 21.6478 15.6753 21.515 15.8192L21.395 15.9472C21.1682 16.1933 21.0307 16.5086 21.0046 16.8423C20.9784 17.1759 21.0652 17.5087 21.251 17.7872L27.187 25.0448L21.251 32.2128C21.0652 32.4912 20.9784 32.824 21.0046 33.1577C21.0307 33.4914 21.1682 33.8066 21.395 34.0528L21.515 34.1808C21.6478 34.3246 21.8114 34.4366 21.9935 34.5085C22.1756 34.5804 22.3716 34.6103 22.5668 34.596C22.7621 34.5817 22.9516 34.5236 23.1213 34.4259C23.291 34.3283 23.4365 34.1936 23.547 34.032L30.3262 25.9072C30.5042 25.6548 30.5998 25.3536 30.5998 25.0448C30.5998 24.736 30.5042 24.4347 30.3262 24.1824L23.547 15.968Z"
			fill="#d2d2d3"
		/>
	</svg>
)
